<form [formGroup]="form" (submit)="onSubmit()" [class.block-loader]="loader && loader.isLoading$ | async">
	<div class="modal-header">
		<div class="row">
			<div class="col-md-12">
				<span class="fw-light" *ngIf="labelNature" [translate]="'Labels.' + labelNature"></span>
				<!-- <span class="fw-light" *ngIf="isToConsult">{{ libelleKey }}</span> -->
				<h2 class="modal-title" *ngIf="!isToConsult && !isToUpdate" translate="TiersForm.Title.CreateTier"></h2>
			</div>
		</div>
		<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
	</div>

	<div class="modal-body">
		<loader-spinner *ngIf="loader" [model]="loader"></loader-spinner>
		<div class="custom-radio-group">
			<div class="row">
				<div class="col-6">
					<label class="custom-radio">
						<input
							id="personnePhysique"
							type="radio"
							formControlName="type"
							value="true"
							[checked]="(isToConsult || isToUpdate) && isPersonnePhysique"
							(change)="onChangeTierType(tiersType.PersonnePhysique)"
						/>
						<span id="tiers-type-personne-physique" class="label-text" translate="Labels.PersonnePhysique"></span>
					</label>
				</div>
				<div class="col-6">
					<label class="custom-radio">
						<input
							id="personneMorale"
							type="radio"
							formControlName="type"
							value="false"
							[checked]="(isToConsult || isToUpdate) && isPersonneMorale"
							(change)="onChangeTierType(tiersType.PersonneMorale)"
						/>
						<span id="tiers-type-personne-morale" class="label-text" translate="Labels.PersonneMorale"></span>
					</label>
					<div *ngIf="isPersonneMorale" class="custom-checkbox-group is-nested">
						<label for="field-institutionnelDroitPublic" class="form-label custom-checkbox">
							<input
								id="field-institutionnelDroitPublic"
								type="checkbox"
								formControlName="institutionnelDroitPublic"
								[class.is-invalid]="institutionnelDroitPublicField.dirty && institutionnelDroitPublicField.invalid"
								(change)="setSirenValidators()"
							/>

							<span style="font-size: 14px" class="label-text" translate="Labels.InstitutionnelDroitPublicPartie1"></span>
						</label>
						<form-control-feedback [field]="institutionnelDroitPublicField"></form-control-feedback>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="isPersonnePhysique">
			<div class="row">
				<div class="col-6">
					<div class="form-group">
						<label for="field-prenom-tiers-front" class="form-label form-label-required" translate="Labels.Prenom"></label>
						<input
							id="field-prenom-tiers-front"
							class="form-control"
							type="text"
							autocomplete="off"
							formControlName="prenom"
							inputUppercaseType="['blurTitleCase']"
							inputRestriction="nomEmetteur"
							[formControl]="prenomField"
							[matTooltip]="disabledFieldsTooltip"
							[class.is-invalid]="prenomField.dirty && prenomField.invalid"
						/>
						<form-control-feedback [field]="prenomField"></form-control-feedback>
					</div>
				</div>
				<div class="col-6">
					<div class="form-group">
						<label for="field-nom-tiers-front" class="form-label form-label-required" translate="Labels.Nom"></label>
						<input
							id="field-nom-tiers-front"
							class="form-control"
							type="text"
							autocomplete="off"
							formControlName="nom"
							inputUppercaseType="['blurUpperCase']"
							inputRestriction="nomEmetteur"
							[formControl]="nomField"
							[matTooltip]="disabledFieldsTooltip"
							[class.is-invalid]="nomField.dirty && nomField.invalid"
						/>
						<form-control-feedback [field]="nomField"></form-control-feedback>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<div class="form-group datepicker-group" style="margin-bottom: 15px">
						<div>
							<label
								for="field-dateNaissance"
								class="form-label"
								[class.form-label-required]="isBirthDateRequired"
								translate="Labels.DateNaissance"></label>
							<div class="position-relative datepicker-input-container">
								<input 
									id="field-dateNaissance" 
									class="form-control" 
									type="text" 
									autocomplete="off" 
									matInput
									[matDatepicker]="pickerDateNaissance" formControlName="dateNaissance"
									[max]="dateNaissanceMaxDate" appDateFormat
									[class.is-invalid]="dateNaissanceField.dirty && dateNaissanceField.invalid" 
									appDateFormat
									/>
	
								<mat-datepicker-toggle matSuffix [for]="pickerDateNaissance"></mat-datepicker-toggle>
								<mat-datepicker #pickerDateNaissance [restoreFocus]="false"></mat-datepicker>

								<form-control-feedback style="position: absolute; top: 2em;" [field]="dateNaissanceField"></form-control-feedback>
							</div>
						</div>
					</div>	
					<div class="row">
						<div class="form-group d-flex flex-row-reverse justify-content-end">
							<label class="form-check-label fst-italic" for="isBirthDateUnknown" translate="Labels.UnknownBirthDate"></label>
							<input
								type="checkbox"
								class="form-check-input"
								style="margin-right: 0.5em; cursor: pointer"
								id="isBirthDateUnknown"
								formControlName="isBirthDateUnknown"
							/>
						</div>
					</div>
				</div>
				<div class="col-6">
					<div class="form-group">
						<label for="field-paysId" class="form-label form-label-required" translate="Labels.Nationalite"></label>

						<ng-select
							[appendTo]="modalContent"
							labelForId="field-paysId"
							formControlName="paysId"
							[class.is-invalid]="paysIdField.dirty && paysIdField.invalid"
							[searchable]="true"
							[placeholder]="'Forms.Placeholder.Select' | translate"
							[notFoundText]="'NgSelect.NotFoundText' | translate"
							[typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
							[loadingText]="'NgSelect.LoadingText' | translate"
							[clearAllText]="'NgSelect.ClearAllText' | translate"
							[ngModel]="selectedPay"
							[clearable]="false"
						>
							<ng-option *ngFor="let nationalite of nationalites$ | async" [value]="nationalite.id">
								{{ nationalite.nom }}
							</ng-option>
						</ng-select>
						<form-control-feedback [field]="paysIdField"></form-control-feedback>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="isPersonneMorale">
			<div class="row">
				<div class="col-6">
					<div class="form-group">
						<label for="field-paysId" class="form-label form-label-required" translate="Labels.PaysSiegeSociale"></label>
						<ng-select
							[appendTo]="modalContent"
							labelForId="field-paysId"
							formControlName="paysId"
							[class.is-invalid]="paysIdField.dirty && paysIdField.invalid"
							[searchable]="true"
							[placeholder]="'Forms.Placeholder.Select' | translate"
							[notFoundText]="'NgSelect.NotFoundText' | translate"
							[typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
							[loadingText]="'NgSelect.LoadingText' | translate"
							[clearAllText]="'NgSelect.ClearAllText' | translate"
							[ngModel]="selectedPay"
							[clearable]="false"
							[formControl]="paysIdField"
							[matTooltip]="disabledFieldsTooltip"
						>
							<ng-option *ngFor="let nationalite of nationalites" [value]="nationalite.id">
								{{ nationalite.nom }}
							</ng-option>
						</ng-select>
						<form-control-feedback [field]="paysIdField"></form-control-feedback>
					</div>
				</div>
			</div>

			<div class="form-group">
				<div class="custom-radio-group">
					<div class="row" style="flex-wrap: nowrap">
						<div class="col-3">
							<label class="custom-radio" [matTooltip]="disableImmatriculationRadios ? disabledFieldsTooltip : null">
								<input
									type="radio"
									name="registre"
									value="siren"
									(change)="onSirenSelected()"
									[checked]="(isPaysSiren && isSirenSelected) || ((isToConsult || isToUpdate) && isSirenSelected)"
									[disabled]="isToConsult || disableImmatriculationRadios"
								/>
								<span class="label-text" [translate]="sirenRadioLabelKey"></span>
							</label>
							<form-control-feedback [field]="sirenRegistreField"></form-control-feedback>
						</div>
						<div class="col-4">
							<label class="custom-radio" [matTooltip]="disableImmatriculationRadios ? disabledFieldsTooltip : null">
								<input
									type="radio"
									name="registre"
									value="regEq"
									autocomplete="off"
									(change)="onRegEqSelected()"
									[checked]="!isPaysSiren && isRegEqSelected"
									[disabled]="isPaysSiren || isToConsult || disableImmatriculationRadios"
								/>
								<span class="label-text" style="position: initial; width: 200px" translate="Labels.RE"></span>
							</label>
						</div>
						<div class="col-5">
							<label class="custom-radio" [matTooltip]="disableImmatriculationRadios ? disabledFieldsTooltip : null">
								<input
									type="radio"
									name="registre"
									value="imo"
									autocomplete="off"
									(change)="onImoSelected()"
									[checked]="isImoSelected"
									[disabled]="isToConsult || disableImmatriculationRadios"
								/>
								<span class="label-text" style="position: initial; width: 200px" translate="Labels.IMO"></span>
							</label>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-7">
						<input
							id="field-siren"
							class="form-control"
							type="text"
							autocomplete="off"
							formControlName="registre"
							[class.is-invalid]="registreField.dirty && registreField.invalid"
							[inputRestriction]="inputRestrictionValue"
							[fieldformControl]="registreField"
							[formControl]="registreField"
							[matTooltip]="disabledFieldsTooltip"
							[(ngModel)]="registreValue"
							[siren]="isSirenSelected"
							(input)="onInputRegistre($event)"
							(keypress)="omitSpecialChar($event)"
							(paste)="onPasteRegistre($event)"
						/>

						<form-control-feedback
							[isFullWidth]="true"
							[messages]="{
								MaxLength: immatriculationErrorMessage,
								wrongRcsFormat: wrongRCSFormatErrorMessage,
							ExactLength: immatriculationErrorMessage,
							LuhnInvalid: luhnErrorMessage
							}"
							[field]="registreField"
						></form-control-feedback>
					</div>
					<div class="col-5">
						<div class="col-12 text-end">
							<div class="d-inline-block" [matTooltip]="canSearchBySiren ? null : 'Actif si SIREN ou RID/SIREN sélectionné avec un SIREN valide'">
								<button
									id="btn-search-by-siren"
									type="button"
									class="btn btn-primary"
									[disabled]="!canSearchBySiren"
									(click)="onSearchBySiren()"
								>
									<i class="far fa-search"></i>
									{{ 'Actions.Search' | translate }}
									<loader-button-spinner [isShowButtonSpinner]="isSearchingBySiren"></loader-button-spinner>
								</button>
							</div>
						</div>
					</div>
					<div *ngIf="sirenSearchErrorMessage" class="text-danger text-end mt-1 col-12">
						<small
							><i>{{ sirenSearchErrorMessage }}</i></small
						>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					<div class="form-group">
						<div>
							<label for="field-formeJuridique" class="form-label" translate="Labels.FormeJuridique"></label>
							<input
								id="field-formeJuridique"
								class="form-control"
								type="text"
								autocomplete="off"
								formControlName="formeJuridique"
								inputUppercaseType="['uppercaseNormalizedNFD']"
								inputRestriction="alpha"
								maxLength="11"
								[class.is-invalid]="formeJuridiqueField.dirty && formeJuridiqueField.invalid"
							/>
						</div>
						<form-control-feedback [field]="formeJuridiqueField"></form-control-feedback>
					</div>
				</div>
				<div class="col-8" style="padding-left: 0;">
					<div class="form-group">
						<label
							for="field-libelle-tiers-front"
							class="form-label form-label-required"
							translate="Labels.LibellePersonneMorale"
						></label>
						<input
							id="field-libelle-tiers-front"
							class="form-control"
							type="text"
							autocomplete="off"
							formControlName="libelle"
							inputRestriction="nomEmetteur"
							inputUppercaseType="['uppercase', 'nomEmetteur']"
							maxLength="30"
							[formControl]="libelleField"
							[matTooltip]="disabledFieldsTooltip"
							[class.is-invalid]="libelleField.dirty && libelleField.invalid"
						/>
						<form-control-feedback [field]="libelleField"></form-control-feedback>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="field-denominationCommerciale" class="form-label" translate="Labels.DenominationCommerciale"></label>
						<input
							#denominationCommerciale
							id="field-denominationCommerciale"
							class="form-control"
							type="text"
							autocomplete="off"
							formControlName="denominationCommerciale"
							inputUppercaseType="['uppercase']"
							maxLength="100"
							[class.is-invalid]="denominationCommercialeField.dirty && denominationCommercialeField.invalid"
							(focus)="hideAutoFillButton()"
						/>
						<form-control-feedback [field]="denominationCommercialeField"></form-control-feedback>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="isPersonneMorale || isPersonnePhysique">
			<div class="row">
				<div class="col-6">
					<div class="form-group">
						<label for="field-telephone-tiers-front" class="form-label" translate="Labels.Telephone"></label>
						<form *ngIf="!isToConsult || telephoneField?.value !== null; else elseBlocPhone" #f="ngForm" [formGroup]="form">
							<div>
								<app-custom-phone-input
									[id]="'field-telephone-tiers-front'"
									[isToConsult]="isToConsult"
									formControlName="telephone"
									[selectedCountryISO]="selectedCountryISO"
								>
								</app-custom-phone-input>
							</div>
							<form-control-feedback [field]="f.form.controls['telephone']"></form-control-feedback>
						</form>
						<ng-template #elseBlocPhone>
							<input id="field-phone-empty" class="form-control" type="text" [disabled]="true" />
						</ng-template>
					</div>
				</div>
				<div class="col-6">
					<div class="form-group">
						<label for="field-mail-tiers-front" class="form-label" translate="Labels.Email"></label>
						<input
							id="field-mail-tiers-front"
							class="form-control"
							type="text"
							autocomplete="off"
							formControlName="email"
							[formControl]="emailField"
							[class.is-invalid]="emailField.dirty && emailField.invalid"
						/>
						<form-control-feedback [field]="emailField"></form-control-feedback>
					</div>
				</div>
			</div>
			<div *ngIf="isPersonneMorale" class="row">
				<adresse
					[isToConsult]="isToConsult"
					[currentAdresse]="currentAdresse"
					[isPersonneMorale]="isPersonneMorale"
					[paysPersonneMoraleId]="paysIdField?.value"
					(changeAdresse)="onChangeAdresse($event)"
				></adresse>
			</div>
			<div *ngIf="isPersonnePhysique" class="row">
				<adresse [isToConsult]="isToConsult" [currentAdresse]="currentAdresse" (changeAdresse)="onChangeAdresse($event)"> </adresse>
			</div>
			<div class="row">
				<div class="col-6" *ngIf="isPersonnePhysique">
					<div class="label-complex" style="display: flex; flex-direction: column">
						<label class="form-label" style="margin-bottom: 0 !important" translate="Labels.PaysResidenceFiscale"> </label>
						<labes class="form-required-fields" translate="Labels.PaysResidenceFiscaleDifferentes"></labes>
					</div>

					<div class="form-group" style="padding-bottom: 20px">
						<ng-select
							[appendTo]="modalContent"
							labelForId="field-paysResidenceFiscalIdField"
							formControlName="paysResidenceFiscalId"
							[class.is-invalid]="paysResidenceFiscalIdField?.dirty && paysResidenceFiscalIdField?.invalid"
							[searchable]="true"
							[placeholder]="'Forms.Placeholder.Select' | translate"
							[notFoundText]="'NgSelect.NotFoundText' | translate"
							[typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
							[loadingText]="'NgSelect.LoadingText' | translate"
							[clearAllText]="'NgSelect.ClearAllText' | translate"
							[clearable]="false"
						>
							<ng-option *ngFor="let currentPays of nationalites$ | async" [value]="currentPays.id">
								{{ currentPays.nom }}
							</ng-option>
						</ng-select>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer" *ngIf="!isToConsult">
		<button type="button" class="btn btn-secondary" translate="Actions.Cancel" (click)="onClose()"></button>
		<button
			id="tiers-save-btn"
			type="submit"
			class="btn btn-primary"
			[disabled]="
				(!isPersonnePhysique && !isPersonneMorale) || (isPersonneMorale && registreField.dirty && registreField.invalid) || isSubmited
			"
			translate="Actions.Save"
		>
			<loader-button-spinner [isShowButtonSpinner]="isSubmited"></loader-button-spinner>
		</button>
	</div>
</form>
